export default "__VITE_ASSET__CcFAUqt___"